import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Legend;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { PresentationContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var Legend = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Legend = /*#__PURE__*/function (_Component) {
  function Legend() {
    _classCallCheck(this, Legend);
    return _callSuper(this, Legend, arguments);
  }
  _inherits(Legend, _Component);
  return _createClass(Legend, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "renderSeries",
    value: function renderSeries(series, index, styles) {
      var customStyles = series.customStyles ? series.customStyles : {};
      return jsx("div", {
        key: index,
        className: "seriesContainer",
        css: styles.seriesContainer
      }, jsx("div", {
        css: styles.seriesSwatchContainer
      }, jsx("div", {
        css: _objectSpread(_objectSpread({}, styles.seriesSwatch), customStyles)
      })), jsx("div", {
        css: styles.seriesLabel
      }, series.label));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        variant = _this$props.variant,
        series = _this$props.series,
        styles = _this$props.styles;
      var containerClass = variant === 'row' ? 'containerRow' : 'containerColumn';
      return jsx(PresentationContent, null, jsx("div", {
        className: containerClass,
        css: styles.containerStyle
      }, series.map(function (s, i) {
        return _this2.renderSeries(s, i, styles);
      })));
    }
  }]);
}(Component), _defineProperty(_Legend, "displayName", 'Legend'), _defineProperty(_Legend, "componentId", "Quizzes".concat(_Legend.displayName)), _defineProperty(_Legend, "propTypes", {
  series: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    customStyles: PropTypes.object.isRequired
  })),
  variant: PropTypes.oneOf(['column', 'row']),
  makeStyles: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_Legend, "defaultProps", {
  series: [],
  variant: 'column'
}), _Legend)) || _class);
export default Legend;